import { theme } from '@orobix/orobix-fe-components'
import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles((t: typeof theme) => ({
  container: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
  },

  topBar: {
    display: 'flex',
    justifyContent: 'flex-end',
  },

  filterSelect: {
    minWidth: '8.75rem',
  },

  listWrapper: {
    display: 'flex',
    flex: 1,
    marginTop: '1rem',
  },

  result: {
    display: 'block',
    width: '1rem',
    height: '1rem',
    borderRadius: '50%',
  },

  true: {
    backgroundColor: t.green01,
  },

  false: {
    backgroundColor: t.red01,
  },

  sortableColumn: {
    display: 'flex',
  },

  sortableColumnHeaderInfo: {
    display: 'content',
  },

  colFilename: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: '10rem',
  },
}))

export default useStyles
